'use client';

import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

import { Icon } from '@/components/ui/icon.component';
import { Pill } from '@/components/ui/pill.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface BrandSectionTopicProps {
  title: string;
  description: string;
}

export const BrandSectionTopic = ({ title, description }: BrandSectionTopicProps) => {
  return (
    <div className="flex gap-4 items-center">
      <Pill className="p-3 rounded-lg w-4 h-4" asChild>
        <Icon icon={faCircleCheck} size="lg" />
      </Pill>
      <div className="flex flex-col">
        <Typography
          variant={TypographyVariant.BODY_TEXT}
          className="font-bold"
        >
          {title}
        </Typography>
        <Typography
          variant={TypographyVariant.MEDIUM_BODY_TEXT}
          className="sm:text-base"
        >
          {description}
        </Typography>
      </div>
    </div>
  );
};
